function imgOnLoad() {
    return {
        restrict: "A",
        link: (scope, element, attrs)  => {
            element.on("load", () => {
                scope.$apply(attrs.imgOnLoad);
            });
        }
    };
}

angular
    .module("thor.core.img-on-load.directive", [])
    .directive("imgOnLoad", imgOnLoad);
